import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpService} from '../http-service.service';
import {ApiConst} from '../api-const';
import {Observable} from 'rxjs';
import {ActionUserFilter} from "../../../model/action-user-filter";

/**
 * Service that handle request for fold details (like get deposits of a fold, get files from a fold...)
 */
@Injectable()
export class FoldDetailService {

  /**
   *
   * @param {HttpService} httpService - here to perform httpRequest
   */
  constructor(private httpService: HttpService) {
  }

  /**
   *
   * get Deposit for a fold
   *
   * @param {number} depositNumber - the fold number for which you want to get deposits
   * @return {Observable<R>} - the response from the back-office
   */
  public getDeposit(depositNumber: number): Observable<any> {

    const datasToSend = JSON.stringify({
      datas: {serialLotDepot: depositNumber}
    });
    return this.httpService.$post(ApiConst.getListOfDeposit, datasToSend).pipe(map((response: Response) => {
      return response;
    }));
  }

  /**
   *
   * get Treatment for a fold
   *
   * @param {number} serialSent - the deposit number for which you want to get the treatment list
   * @return {Observable<R>} - the response from the back-office
   */
  public getTreatment(serialSent: number): Observable<any> {

    const datasToSend = JSON.stringify({
      datas: {serialSent: serialSent}
    });
    return this.httpService.$post(ApiConst.getTrackingList, datasToSend).pipe(map((response: Response) => {
      return response.body;
    }));
  }
  public getTrackingUser(customerID: string): Observable<any> {

    const datasToSend = JSON.stringify({
      datas: {customerID: customerID}
    });
    return this.httpService.$post(ApiConst.getTrackingUserList, datasToSend).pipe(map((response: Response) => {
      return response.body;
    }));
  }

  public getTrackingDetailsUserList(filterUserList: ActionUserFilter): Observable<any> {
    const datasToSend = JSON.stringify({
      datas: {
        customerID: filterUserList.customerID,
        action: filterUserList.action,
        beginningDate: filterUserList.beginningDate,
        endDate: filterUserList.endDate,
        user: filterUserList.user
      }
    });
    return this.httpService.$post(ApiConst.getTrackingDetailsUserList, datasToSend).pipe(map((response: Response) => {
      return response.body;
    }));
  }
  /**
   *
   * get postal Treatment for a fold
   *
   * @param {number} serialSent - the deposit number for which you want to get the treatment list
   * @return {Observable<R>} - the response from the back-office
   */
  public getPostalTreatment(serialSent: number): Observable<any> {

    const datasToSend = JSON.stringify({
      datas: {serialSent: serialSent}
    });
    return this.httpService.$post(ApiConst.getPostalTrackingList, datasToSend).pipe(map((response: Response) => {
      return response.body;
    }));
  }
  /**
   *
   * get Treatment for an ERL fold
   *
   * @param {number} depositNumber - the deposit number for which you want to get the treatment list
   * @return {Observable<R>} - the response from the back-office
   */
  public getErlTrackingList(erlId: number): Observable<any> {

    const datasToSend = JSON.stringify({
      datas: {erlId: erlId}
    });
    return this.httpService.$post(ApiConst.getErlTrackingList, datasToSend).pipe(map((response: Response) => {
      return response.body;
    }));
  }
  /**
   *
   * get Treatment for an Email fold
   *
   * @param {number} serialSent - the sent number for which you want to get the treatment list
   * @return {Observable<R>} - the response from the back-office
   */
  public getEmailTrackingList(serialSent: number): Observable<any> {

    const datasToSend = JSON.stringify({
      datas: {serialSent: serialSent}
    });
    return this.httpService.$post(ApiConst.getEmailTrackingList, datasToSend).pipe(map((response: Response) => {
      return response.body;
    }));
  }

  /**
   *
   * Get file content for the given param
   *
   * @param {string} filename - filename given by the back-office in the first place (in search)
   * @param {string} filepath - filepath given by the back-office in the first place (in search)
   * @param type
   * @return {Observable<R>} - the response from the back-office
   */
  public getFileContent(filename: string, filepath: string, type): Observable<any> {
    const datasToSend = JSON.stringify({
      datas: {
        fileName: filename,
        filePath: filepath,
        type: type
      }
    });
    return this.httpService.$post(ApiConst.getFileContent, datasToSend).pipe(map((response: Response) => {
      return response;
    }));
  }
  /**
   *
   * Get file content for download for the given param
   *
   * @param {string} filename - filename given by the back-office in the first place (in search)
   * @param {string} filepath - filepath given by the back-office in the first place (in search)
   * @return {Observable<R>} - the response from the back-office
  */
  public downloadFileContent(filename: string, filepath: string, type: string): Observable<any> {
    const datasToSend = JSON.stringify({
      datas: {
        fileName: filename,
        filePath: filepath,
        type: type
      }
    });
    return this.httpService.$post(ApiConst.downloadFileContent, datasToSend).pipe(map((response: Response) => {
      return response;
    }));
  }
  public getFileContentBySerialSent(serialsent: string): Observable<any> {
    const datasToSend = JSON.stringify({
      datas: {
        serialSent: serialsent
      }
    });
    return this.httpService.$post(ApiConst.getFileContentBySerialSent, datasToSend).pipe(map((response: Response) => {
      return response;
    }));
  }
  public downloadFileContentBySerialSent(serialsent: string): Observable<any> {
    const datasToSend = JSON.stringify({
      datas: {
        serialSent: serialsent
      }
    });
    return this.httpService.$post(ApiConst.downloadFileContentBySerialSent, datasToSend).pipe(map((response: Response) => {
      return response;
    }));
  }

  /**
   *
   * Get file content as Text file for the given param
   *
   * @param {string} filename - filename given by the back-office in the first place (in search)
   * @param {string} filepath - filepath given by the back-office in the first place (in search)
   * @return {Observable<R>} - the response from the back-office
   */
  public getFileAsText(filename: string, filepath: string): Observable<any> {
    const datasToSend = JSON.stringify({
      datas: {
        fileName: filename,
        filePath: filepath
      }
    });
    return this.httpService.$post(ApiConst.getFileAsText, datasToSend).pipe(map((response: Response) => {
      return response;
    }));
  }

  /**
   *
   * perform action Request on folds
   *
   * @param {string} justification - the justification gave by the user
   * @param {string} serialDeposit - the deposit number
   * @param {string} serialSent - the send number
   * @param {string} action - the asked action
   * @param {string} operationMode - unit or lot (gave by component)
   * @return {Observable<R>} - the response gave by the back-office
   */
  public planFolds(justification: string, serialDeposit: string, serialSent: string, action: string, operationMode: string): Observable<any> {
    const datasToSend = JSON.stringify({
      justif: justification,
      operationMode: operationMode,
      serialLotDepot: serialDeposit,
      opeartion: action,
      serialSent: serialSent
    });

    return this.httpService.$post(ApiConst.planFold, datasToSend).pipe(map((response: Response) => {
      return response.body;
    }));
  }
  /**
   *
   * perform action Request on folds
   *
   * @param {string} justification - the justification gave by the user
   * @param {string} serialDeposit - the deposit number
   * @param {string} serialSent - the send number
   * @param {string} action - the asked action
   * @param {string} operationMode - unit or lot (gave by component)
   * @return {Observable<R>} - the response gave by the back-office
   */
  public actionOnFold(justification: string, serialDeposit: string, serialSent: string, action: string, operationMode: string, delayedSendDate: Date): Observable<any> {
    const datas = {
      justif: justification,
      operationMode: operationMode,
      serialLotDepot: serialDeposit,
      operation: action,
      serialSent: serialSent
    };
    let request = ApiConst.retryFold;
    if (action === 'CANCEL_PLAN' || action === 'PLAN') {
      request = ApiConst.planFold;
    }
    if (action === 'PLAN') {
      const selectMonth = delayedSendDate.getMonth() + 1 ;
      const mm = ( selectMonth < 10) ? '0' + selectMonth : selectMonth;
      const dd = (delayedSendDate.getDate() < 10) ? '0' + delayedSendDate.getDate() : delayedSendDate.getDate();
      datas['plannedForDate'] = delayedSendDate.getFullYear() + '/' + mm + '/' + dd;
    }
    const datasToSend = JSON.stringify(datas);
    return this.httpService.$post(request, datasToSend).pipe(map((response: Response) => {
      return response.body;
    }));
  }
  /**
   *
   * perform action Request on folds
   *
   * @param {string} justification - the justification gave by the user
   * @param {string} serialDeposit - the deposit number
   * @param {string} serialSent - the send number
   * @param {string} action - the asked action
   * @param {string} operationMode - unit or lot (gave by component)
   * @return {Observable<R>} - the response gave by the back-office
   */
  public actionOnFoldList(justification: string, serialSentList: string[], action: string, operationMode: string): Observable<any> {
    const datasToSend = JSON.stringify({
      justif: justification,
      operationMode: operationMode,
      opeartion: action,
      serialSentList: serialSentList
    });

    return this.httpService.$post(ApiConst.retryFold, datasToSend).pipe( map((response: Response) => {
      return response;
    }) );
  }

  /**
   *
   * function that handle the number of impacted fold depending on action
   *
   * @param {string} depositNumber : the fold deposit number
   * @param {string} action : kind of wished action: NewRun / Restore / Dismiss
   * @return the folds count as an observable (0) if the request failed
   */
  public getNumberOfFoldByDepositNumber(depositNumber: string, action: string): Observable<number> {
    const datasToSend = JSON.stringify({
      serialLotDepot: depositNumber,
      opeartion: action,
    });
    return this.httpService.$post(ApiConst.getNumberOfFoldFromDeposit, datasToSend).pipe(map((response) => {
      if (response && response.body.datas && response.body.datas && response.body.datas.foldsCount) {
        return response.body.datas.foldsCount;
      }
      else {
        return 0;
      }
    }));
  }
  /**
   *
   * Get file content for the given param
   *
   * @param {string} filename - filename given by the back-office in the first place (in search)
   * @param {string} filepath - filepath given by the back-office in the first place (in search)
   * @return {Observable<R>} - the response from the back-office
   */
  public getMailCourrierFiles(token: string): Observable<any> {
    const datasToSend = JSON.stringify({
      datas: {
        token: token,
      }
    });
    return this.httpService.$post(ApiConst.getMailCourrierFiles, datasToSend).pipe(map((response: Response) => {
      return response;
    }));
  }
  public getReportFile(token: string): Observable<any> {
    const datasToSend = JSON.stringify({
      datas: {
        token: token,
      }
    });
    return this.httpService.$post(ApiConst.getReportFile, datasToSend).pipe(map((response: Response) => {
      return response;
    }));
  }
}

